import { render, staticRenderFns } from "./MainSettingsModule.vue?vue&type=template&id=34376ede"
import script from "./MainSettingsModule.vue?vue&type=script&lang=js"
export * from "./MainSettingsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports